var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"arrow-right-1--arrow-right-keyboard"},[React.createElement("path",{"id":"Vector 2","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","d":"M13 7H1","key":0}),React.createElement("path",{"id":"Vector","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","d":"M9.004 3C11 4 12 5 13 7c-1 2-2 3-3.996 4","key":1})]));
}

ArrowRight.defaultProps = {"fill":"none","viewBox":"0 0 14 14","height":"18","width":"18"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
